import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";

import { userFetchError, userFetchRequest, userFetchSuccess } from "./actions";
import { UserActionTypes } from "./types";

function* handleUserFetchRequest(action: ReturnType<typeof userFetchRequest>): SagaIterator {
  try {
    const res = yield call(callGet, "/users/me/");
    yield put(userFetchSuccess({ user: res.data, gateId: action.payload }));
  } catch (err) {
    yield put(userFetchError(err.message));
  }
}

function* watchUserSagas(): SagaIterator {
  yield takeLatest(UserActionTypes.FETCH_REQUEST, handleUserFetchRequest);
}

export default watchUserSagas;
